module.exports = __webpack_public_path__ + "static/media/Earned-Positions-Ex-UK-Online-v2.e94190f2.pdf";